import React from "react";
import "./PhoneCall.css";

function PhoneCall(props) {
  const { className } = props;

  return (
    <div className={`phone-call ${className || ""}`}>
      <img className="vector-30" src="/img/vector-17@2x.png" />
    </div>
  );
}

export default PhoneCall;
